<template>
  <div>
    <b-modal
      ref="modal"
      id="modal-no-backdrop"
      hide-backdrop
      content-class="shadow"
      :title="'Confirma o cancelamento da venda?'"
       no-close-on-backdrop
    >
      <div class="container-fluid">
        <div class="row"></div>
        <br />
        <div class="row">
          <div class="col-12">
            <h3>Venda #{{ order.number }}</h3>
            <br />
            <p class="my-2">
              Verificar no menu
              <code>'Contas a receber'</code>
              o registro referente a venda .
            </p>
          </div>
        </div>
        <br />
      </div>

      <div slot="modal-footer">
        <button role="button" class="btn btn-outline-secondary" @click="$refs.modal.hide()">
          <i class="fas fa-times"></i> Não Cancelar
        </button>
        <button role="button" class="btn btn-danger" style="margin-left:5px" @click="store">
          <i class="fas fa-check"></i> Cancelar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Filters from "./../../mixins/Filters.js";
import Form from "./../../mixins/Form.js";

export default {
  data: function() {
    return {
      order: {},
    };
  },
  methods: {

      open(order) {

      this.order = order
      this.$refs.modal.show();
     
    },

    store() {
      this.$store.commit("showLoading");
      axios
        .post("api/order/cancel", {id : this.order.id})
        .then(response => {
          this.$store.commit("hideLoading");

          this.$refs.modal.hide();

          this.$emit("stored");
        })
        .catch(error => {
          this.$store.commit("hideLoading");

          this.error = error;
        });
    },
  }
};
</script>

<style>
</style>